module.exports = __webpack_public_path__ + "static/media/spinnere1b01633.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/spinner.svg
// module id = 1422
// module chunks = 0